/* Perfume Gyaan — product card image auto-slideshow. Fades through each card's images (in-view only). */
(function(){
  function inView(el){var r=el.getBoundingClientRect();var h=window.innerHeight||document.documentElement.clientHeight||0;if(!h)return true;return r.bottom>0 && r.top<h;}
  function tick(){
    var medias=document.querySelectorAll('.card-media');
    for(var i=0;i<medias.length;i++){
      var m=medias[i];
      var imgs=m.querySelectorAll('.cimg');
      if(imgs.length<2) continue;
      if(!inView(m)) continue;
      var cur=m.querySelector('.cimg.on')||imgs[0];
      var idx=Array.prototype.indexOf.call(imgs,cur);
      var next=imgs[(idx+1)%imgs.length];
      if(next!==cur){ cur.classList.remove('on'); next.classList.add('on'); }
    }
  }
  var iv=null;
  function start(){ if(iv||!document.querySelector('.cimg'))return; iv=setInterval(tick,3400); }
  function stop(){ if(iv){clearInterval(iv);iv=null;} }
  if(document.readyState!=='loading') start(); else document.addEventListener('DOMContentLoaded',start);
  document.addEventListener('visibilitychange',function(){ document.hidden?stop():start(); });
})();
